// Copyright 2019 Drivetrain Hub LLC
// GraphQL request helpers for CAD API.

// region QUERY SCHEMA

// PLACEHOLDER {feature} query LogCAD to list CAD quote in DialogExportCad

// endregion

// region MUTATION INPUTS

const FileType = {
  STEP: 'STEP',
  IGES: 'IGES',
};

// endregion

export default {
  FileType: FileType,
}
